import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';
import { GlobalsService } from '../services/globals.service';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { QuotationsService } from '../services/quotations.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-reportview',
  templateUrl: './reportview.component.html',
  styleUrls: ['./reportview.component.less']
})
export class ReportviewComponent implements OnInit {
  reportHeader: string = "";
  reportData: ReportData;
  modules: Array<ReportModule> = [];
  totals: Array<ReportTotal> = [];
  proformaDetail: ProformaDetail;

  totalTuitionFee: number = 0;
  registrationFee: number = 0;
  resAccommodationFee: number = 0;
  trustedURL: SafeUrl;

  constructor(private data: DataService,
    private globals: GlobalsService,
    private service: QuotationsService,
    private sanitizer: DomSanitizer,
    private notifier: SnotifyService) { 
  }

  ngOnInit() {
    this.data.changePage("report");
    if(this.globals.quotationDetail){
      this.data.isLoading(true);
      this.resolveReportHeader();
      
      this.service.getRegistrationFee().subscribe(result => {
        this.registrationFee = result as number;
      }, error => {
        this.data.isLoading(false);
        console.log("Error on getRegistrationFee: ", error);
        this.showError('getRegistrationFee');
      }, () =>{
        this.loadReportData();

        /*=============================================================================================================*/
        // Variables to generate empty template
        /*=============================================================================================================*/
        /*
        let reportData2: ReportData = {report: this.reportData.report, surname: '', surnameInitals: '', faculty: '',
          studyYear: this.reportData.studyYear, programme: -1, studyCourse: '', yearLevel: -1, studentType: -1, 
          regFee: this.reportData.regFee, sendEmail: this.reportData.sendEmail, emailAddress: this.reportData.emailAddress};
          this.modules = []; this.totals = []; 
          let proformaDetail2: ProformaDetail = {funderName: '', addressLine1: '', addressLine2: '', city: '',
            postalCode: '', country: '', contactNo: '', companyRegNo: '', vatNo: '', contactPerson: ''}
            */
          /*=============================================================================================================*/

        this.service.generateReport(this.reportData, this.modules, this.totals, this.proformaDetail).subscribe(result => {
         var file = 'data:application/pdf;base64,' + result;
         this.trustedURL = this.sanitizer.bypassSecurityTrustResourceUrl(file);
        }, error => {
          this.data.isLoading(false);
          console.log("Error on generateReport: ", error);
          this.showError('generateReport');
        }, () => {
          this.data.isLoading(false);

          if(this.globals.quotationDetail.personalInfo.sendEmail){
            let eDocument = 'Quotation';
            if(this.globals.quotationDetail.generateQuotation && this.globals.quotationDetail.generateProforma) eDocument += ' and Proforma Invoice';
            else if(!this.globals.quotationDetail.generateQuotation && this.globals.quotationDetail.generateProforma) eDocument = 'Proforma Invoice';
            this.notifier.success(eDocument.concat(' sent to your email address'));
          }
        })
      });
    }
  }

  resolveReportHeader(){
    if(this.globals.quotationDetail.generateQuotation && !this.globals.quotationDetail.generateProforma){
      this.reportHeader = "Quotation";
    }
    else if(!this.globals.quotationDetail.generateQuotation && this.globals.quotationDetail.generateProforma){
      this.reportHeader = "Pro-forma Invoice";
    }
    else {
      this.reportHeader = "Quotation and Pro-forma Invoice";
    }
  }

  loadReportData() {
    this.globals.quotationDetail.quotationsModules.forEach(mod => {
      var module: ReportModule = {
        moduleYear: this.globals.quotationDetail.academicYear, 
        moduleCode: mod.moduleCode, 
        moduleName: mod.moduleName, 
        moduleCost: mod.moduleCost
      };
      this.modules.push(module);
      if(this.globals.quotationDetail.chargeByModule == true) {
        this.totalTuitionFee += module.moduleCost;
      }
    });

    if(this.globals.quotationDetail.chargeByModule == false){
      this.totalTuitionFee = this.globals.quotationDetail.programmeCost;
    }

    var totalTuition: ReportTotal = {
      year: this.globals.quotationDetail.academicYear, 
      description: "Total Tuition Fees", 
      amount: this.totalTuitionFee
    };
    this.totals.push(totalTuition);   

    var totalRegistration = {
      year: this.globals.quotationDetail.academicYear, 
      description: "Registration Fees", 
      amount: this.registrationFee
    };
    this.totals.push(totalRegistration);

    if(this.globals.quotationDetail.includeRes && this.globals.quotationDetail.residence){
      var totalAccommodation = {
        year: this.globals.quotationDetail.academicYear, 
        description: this.globals.quotationDetail.residence.roomTypeName, 
        amount: this.globals.quotationDetail.residence.maxPrice
      };
      this.totals.push(totalAccommodation);
    }

    if(this.globals.quotationDetail.generateProforma && this.globals.quotationDetail.proformaInfo){
      this.proformaDetail = {
        funderName: this.globals.quotationDetail.proformaInfo.companyName,
        addressLine1: this.globals.quotationDetail.proformaInfo.addressLine1,
        addressLine2: this.globals.quotationDetail.proformaInfo.addressLine2,
        city: this.globals.quotationDetail.proformaInfo.city,
        postalCode: this.globals.quotationDetail.proformaInfo.postalCode,
        country: this.globals.quotationDetail.proformaInfo.country,
        contactNo: this.globals.quotationDetail.proformaInfo.contactNumber,
        companyRegNo: this.globals.quotationDetail.proformaInfo.companyRegNumber,
        vatNo: this.globals.quotationDetail.proformaInfo.vatNumber,
        contactPerson: this.globals.quotationDetail.proformaInfo.contactPerson
      }
    }

    let reportNames: string = "";
    if(this.globals.quotationDetail.generateQuotation){
      reportNames = "Quotation";
    }
    if(this.globals.quotationDetail.generateProforma){
      if(reportNames != "") reportNames += ",";
      reportNames += "Proforma";
    }

    this.reportData = {
      report: reportNames,
      surname: this.globals.quotationDetail.personalInfo.surname,
      surnameInitals: this.globals.quotationDetail.personalInfo.surname + ", " + this.globals.quotationDetail.personalInfo.initials,
      studyYear: this.globals.quotationDetail.academicYear,
      faculty: this.globals.quotationDetail.facultyName,
      programme: this.globals.quotationDetail.programmeId,
      studyCourse: this.globals.quotationDetail.programmeName,
      progStream: this.globals.quotationDetail.streamName,
      yearLevel: this.globals.quotationDetail.yearLevelId,
      studentType: this.globals.quotationDetail.studentType,
      regFee: this.registrationFee,
      sendEmail: this.globals.quotationDetail.personalInfo.sendEmail,
      emailAddress: this.globals.quotationDetail.personalInfo.email
    }
  }

  showError(source: string){
    this.notifier.error('An error occurred at ' + source + '. Please try again and if the problem persists, please contact support at servicedesk@uwc.ac.za', {
      timeout: 0,
      position: SnotifyPosition.centerCenter,
      closeOnClick: false,
      buttons: [
        {text: 'Ok'}
      ]
    });
  }
}

interface ReportData {
  report: string;
  surname: string;
  surnameInitals: string;
  studyYear: number;
  faculty: string;
  programme: number;
  studyCourse: string;
  progStream: string;
  yearLevel: number;
  studentType: number;
  regFee: number;
  sendEmail: boolean;
  emailAddress: string;
}

interface ReportModule {
  moduleYear: number;
  moduleCode: string;
  moduleName: string;
  moduleCost: number;
}

interface ReportTotal {
  year: number;
  description: string;
  amount: number;
}

interface ProformaDetail {
  funderName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  postalCode: string;
  country: string;
  contactNo: string;
  companyRegNo: string;
  vatNo: string;
  contactPerson: string;
}




